import React from 'react';
import NProgress from 'nprogress';
import Router from 'next/router';
import Head from 'next/head';
import { AppProps } from 'next/app';
import { ApolloProvider } from '@apollo/client';
import { SessionProvider } from 'next-auth/react';
import { NextComponentType } from 'next';
import {
  ThemeContextProvider,
  ToastContextProvider,
  UserContextProvider,
} from '../context';
import { useApollo } from '../hooks';
import { ShopCartContextProvider } from '../context/ShopCartContext';
import { Auth } from '../components';
import icon from '../public/images/favicon.ico';
import '../style.css';

type CustomAppProps = AppProps & {
  Component: NextComponentType & { auth?: boolean }; // add auth type to protect routes
};

// @ts-expect-error err is not defined
function MyApp({ Component, pageProps, err }: CustomAppProps<any>) {
  const apolloClient = useApollo(pageProps.initialApolloState);
  React.useEffect(() => {
    Router.events.on('routeChangeStart', () => {
      NProgress.start();
    });

    Router.events.on('routeChangeComplete', () => {
      NProgress.done();
    });

    Router.events.on('routeChangeError', () => {
      NProgress.done();
    });
  }, []);

  return (
    <SessionProvider session={pageProps.session} refetchInterval={0}>
      <ApolloProvider client={apolloClient}>
        <>
          <Head>
            <link rel="icon" href={icon.src} />
            <title>Admin | Meit!</title>
          </Head>
          <ThemeContextProvider>
            <ToastContextProvider>
              {Component?.auth ? (
                <Auth>
                  <UserContextProvider>
                    <ShopCartContextProvider>
                      <Component {...pageProps} err={err} />
                    </ShopCartContextProvider>
                  </UserContextProvider>
                </Auth>
              ) : (
                <Component {...pageProps} />
              )}
            </ToastContextProvider>
          </ThemeContextProvider>
        </>
      </ApolloProvider>
    </SessionProvider>
  );
}

export default MyApp;
